import React from 'react'
import { resolveQuery } from '../helpers'
import { Entry, Resolution } from '../../EntryListItem/Entry'
import { EntryData } from './EntryData'
import '../TrafficEntry.module.sass'
import { EntryPoint } from './ResolutionData'

interface ProcessNameProps {
  entry: Entry,
  point: EntryPoint
}

export const ProcessName: React.FC<ProcessNameProps> = ({ entry, point }) => {
  const resolution: Resolution = entry[point]

  const entryData = {
    processName: resolution?.processName ? resolution?.processName : '-',
  }

  return <EntryData
    name={entryData.processName}
    query={resolveQuery(`${point}.processName`, '==', entryData.processName)}
    zIndex={3}
  />
}
